

import React from "react";
import { Layout, Typography, Anchor, Divider, Button } from "antd";
import { ArrowLeftOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import BgImg from '../../assets/TermsBgImg.png'

const { Header, Content, Footer } = Layout;
const { Title, Paragraph, Text } = Typography;

// const LeafMotif = () => (
//   <svg
//     viewBox="0 0 260 900"
//     xmlns="http://www.w3.org/2000/svg"
//     className="pointer-events-none select-none absolute top-0 right-0 h-full w-36 sm:w-48 md:w-60 opacity-95"
//     preserveAspectRatio="xMaxYMin slice"
//   >
//     <defs>
//       <linearGradient id="leafTeal" x1="0" y1="0" x2="1" y2="1">
//         <stop offset="0%" stopColor="#064E3B" />
//         <stop offset="100%" stopColor="#064E3B" stopOpacity="0.28" />
//       </linearGradient>
//       <linearGradient id="vineTeal" x1="0" y1="0" x2="0" y2="1">
//         <stop offset="0%" stopColor="#064E3B" stopOpacity="0.85" />
//         <stop offset="100%" stopColor="#064E3B" stopOpacity="0.35" />
//       </linearGradient>
//       <linearGradient id="leafGold" x1="0" y1="0" x2="1" y2="1">
//         <stop offset="0%" stopColor="#b69c66" />
//         <stop offset="100%" stopColor="#E5E2D9" />
//       </linearGradient>
//     </defs>

//     {/* connecting vine */}
//     <path
//       d="M228,10 C170,90 250,180 200,260 C150,340 90,380 110,470 C130,560 60,600 80,700 C95,770 40,820 70,900"
//       fill="none"
//       stroke="url(#vineTeal)"
//       strokeWidth="5"
//       strokeLinecap="round"
//     />

//     {/* --- top cluster --- */}
//     <g transform="translate(206,130) rotate(18)">
//       <g transform="rotate(-30)">
//         <path d="M0,0 C -22,-58 -22,-118 0,-165 C 22,-118 22,-58 0,0 Z" fill="url(#leafTeal)" />
//       </g>
//       <g transform="rotate(2)">
//         <path d="M0,0 C -26,-70 -26,-150 0,-205 C 26,-150 26,-70 0,0 Z" fill="url(#leafTeal)" opacity="0.9" />
//         <path d="M0,-6 C -12,-60 -12,-120 0,-172 C 12,-120 12,-60 0,-6 Z" fill="url(#leafGold)" opacity="0.85" />
//       </g>
//       <g transform="rotate(34)">
//         <path d="M0,0 C -20,-52 -20,-104 0,-146 C 20,-104 20,-52 0,0 Z" fill="url(#leafTeal)" opacity="0.75" />
//       </g>
//     </g>

//     {/* --- bottom, larger cluster --- */}
//     <g transform="translate(96,600) rotate(6)">
//       <g transform="rotate(-34)">
//         <path d="M0,0 C -30,-78 -30,-158 0,-222 C 30,-158 30,-78 0,0 Z" fill="url(#leafTeal)" />
//       </g>
//       <g transform="rotate(0)">
//         <path d="M0,0 C -36,-96 -36,-198 0,-272 C 36,-198 36,-96 0,0 Z" fill="url(#leafTeal)" opacity="0.92" />
//         <path d="M0,-8 C -17,-84 -17,-166 0,-230 C 17,-166 17,-84 0,-8 Z" fill="url(#leafGold)" opacity="0.9" />
//       </g>
//       <g transform="rotate(36)">
//         <path d="M0,0 C -27,-70 -27,-142 0,-198 C 27,-142 27,-70 0,0 Z" fill="url(#leafTeal)" opacity="0.7" />
//       </g>
//     </g>
//   </svg>
// );

const sections = [
  {
    id: "commitment",
    title: "1. Our Commitment to Your Privacy",
    body: `VEdanova is an Ayurvedic clinic dedicated to women's health, fertility, and wellness. We understand that the information you share with us, especially around fertility and reproductive health, is deeply personal. This Privacy Policy explains what we collect, why, and how we protect it.`,
  },
  {
    id: "collect",
    title: "2. Information We Collect",
    body: `We collect your name, contact details, and appointment information; medical and health history including menstrual cycle, fertility, and pregnancy-related data shared during consultations; payment details processed via secure third-party gateways; and basic usage data when you visit our website or app.`,
  },
  {
    id: "use",
    title: "3. How We Use Your Information",
    body: `Your information is used to provide personalised Ayurvedic consultations and treatment plans, manage appointments and billing, send appointment reminders and wellness follow-ups, and improve our services. We never use your health data for advertising purposes.`,
  },
  {
    id: "consent",
    title: "4. Consent for Sensitive Health Data",
    body: `Given the sensitive nature of fertility and reproductive health information, we obtain your explicit consent before recording or using such data, and only your treating practitioner accesses it for the purpose of your care.`,
  },
  {
    id: "security",
    title: "5. How We Protect Your Data",
    body: `We use encrypted storage, restricted staff access, and secure servers to safeguard your records. Physical case files, where used, are kept in locked storage accessible only to authorised clinical staff.`,
  },
  {
    id: "sharing",
    title: "6. Sharing & Disclosure",
    body: `We do not sell or rent your personal or health information. Limited data may be shared with your treating practitioners, secure payment processors, or where required by Indian law or a valid legal request.`,
  },
  {
    id: "retention",
    title: "7. Data Retention",
    body: `We retain your medical and consultation records for as long as necessary to provide ongoing care and to meet legal recordkeeping requirements, after which they are securely archived or deleted.`,
  },
  // {
  //   id: "rights",
  //   title: "8. Your Rights",
  //   body: `You may request access to, correction of, or deletion of your personal data, and may withdraw consent for future data collection at any time. Withdrawing consent may affect our ability to continue certain treatments.`,
  // },
  // {
  //   id: "cookies",
  //   title: "9. Cookies & Tracking",
  //   body: `Our website may use cookies to remember your preferences and understand how our site is used. You can control cookie settings through your browser at any time.`,
  // },
  // {
  //   id: "children",
  //   title: "10. Children's Privacy",
  //   body: `Our services are intended for adults and minors accompanied by a parent or guardian. We do not knowingly collect data from unaccompanied minors.`,
  // },
  {
    id: "changes",
    title: "11. Changes to This Policy",
    body: `We may update this Privacy Policy from time to time to reflect changes in our practices or applicable law. The updated version will be posted here with a revised date.`,
  },
  {
    id: "contact",
    title: "12. Contact Us / Grievance Officer",
    body: `For any privacy-related questions or concerns, please reach out to our Grievance Officer using the details below.`,
  },
];

export default function PrivacyPolicy() {
  return (
    <Layout className="min-h-screen bg-[#faf6ee] relative overflow-hidden">


      <Content  style={{
    backgroundImage: `url(${BgImg})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right center",
    backgroundSize: "700px auto",
  }} className="relative z-10 px-6 sm:px-10 md:px-16 py-10 sm:py-14">
        <div className="max-w-4xl mx-auto">
         <div className="flex w-full justify-center item-center text-center flex-col">
           <p className="uppercase md:text-xl text-base font-extrabold text-brand-gold">
            Legal
          </p>
          <h1
            level={1}
            className="text-4xl lg:text-5xl font-bold text-brand-forest"
          >
            Privacy Policy
          </h1>
          <p className="font-['Inter'] text-gray-500 mt-4 mb-8">
            Your trust matters to us. Here&rsquo;s how VEdanova collects, uses, and
            protects your personal and health information.
          </p>
         </div>

          <Divider className="!border-brand-lightgold" />

          <div className="flex flex-col md:flex-row gap-10 md:gap-16">
         
            {/* Sections */}
            <div className="flex-1 min-w-0">
              {sections.map((section, idx) => (
                <section key={section.id} id={section.id} className="scroll-mt-12">
                  <h1
                    className="!font-['Cormorant_Garamond'] font-semibold !text-brand-forest md:!text-2xl text-xl !mb-3"
                  >
                    {section.title}
                  </h1>
                  <Paragraph className="font-['Inter'] text-[15px] text-gray-900">
                    {section.body}
                  </Paragraph>
                  {idx < sections.length - 1 && (
                    <Divider className="!border-brand-lightgold !my-6" />
                  )}
                </section>
              ))}

              <div className="mt-2 rounded-2xl bg-brand-emerald border border-brand-lightgold p-6 sm:p-8">
                <Title level={4} className="!font-['Cormorant_Garamond'] !text-brand-forest !mb-3">
                  Grievance Officer
                </Title>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-10 font-['Inter'] text-sm text-brand-forest/80">
                  <span className="flex items-center gap-2">
                    <MailOutlined className="text-brand-gold" /> privacy@vedanova.com
                  </span>
                  <span className="flex items-center gap-2">
                    <PhoneOutlined className="text-brand-gold" /> +91 98765 43210
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
}